import { render, staticRenderFns } from "./VisualSelect.vue?vue&type=template&id=2e64052c&scoped=true&"
import script from "./VisualSelect.vue?vue&type=script&lang=js&"
export * from "./VisualSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e64052c",
  null
  
)

export default component.exports